import { Outlet, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AppHelmet from "../component/AppHelmet";
import {useDispatch} from "react-redux";
import {getMetaData} from "../store/actions/app";

export default function LanguageLayout() {
    const { i18n } = useTranslation();
    const { lng } = useParams();
    const dispatch = useDispatch();

    useEffect(() => {
        if (lng && i18n.language !== lng) {
            i18n.changeLanguage(lng);
        }
    }, [lng, i18n]);

    useEffect(() => {
        dispatch(getMetaData());
    }, [dispatch]);


    return (
        <>
            <AppHelmet />
            <Outlet />
        </>
    );
}
